import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export const cacheReady = createAction(`${reduxKey}.CACHE_READY`, (name, data)=>({
        name,
        data
    }));
